<template>
  <b-sidebar
    width="80%"
    v-model="toggleSideBar"
    title="Permissions"
    backdrop-variant="dark"
    backdrop
    no-header
    right
    shadow
    @hidden="$emit('hidden')"
  >
    <template>
      <div
        class="d-flex text-light align-items-center px-3 py-2"
        style="background-color: #495057"
      >
        <strong class="mr-auto">Permissions</strong>
        <b-button size="sm" @click="$emit('hidden')">Close</b-button>
      </div>
      <div class="px-3 py-2">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="col-lg-12">
                  <h4 class="card-title mb-4">Search Permissions</h4>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="inline">
                        <b-input-group class="mb-2 mr-sm-3">
                          <b-input-group-prepend>
                            <b-input-group-text>
                              <i class="bx bx-search"></i>
                            </b-input-group-text>
                          </b-input-group-prepend>
                          <b-input
                            type="text"
                            id="inlineSearch"
                            v-model="filter.keyword"
                            placeholder="Permission Name / Action Privilege / Category / Area / Category Group"
                          ></b-input>
                        </b-input-group>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12 text-sm-right">
                      <div class="button-items">
                        <button
                          type="button"
                          class="btn btn-primary waves-effect"
                          @click="onFilter()"
                        >
                          <i
                            class="bx bx-search font-size-16 align-middle mr-2"
                          ></i>
                          Search
                        </button>
                        <button
                          type="button"
                          class="btn btn-light waves-effect"
                        >
                          <i
                            class="bx bx-reset font-size-16 align-middle mr-2"
                          ></i>
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card" v-if="showDataTable">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Size&nbsp;
                        <b-form-select
                          v-model="paginationPermission.pageSize"
                          size="sm"
                          :options="pageOptions"
                        ></b-form-select
                        >&nbsp;Records
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label
                        class="d-inline-flex align-items-center"
                        style="min-width: 200px"
                      >
                        <b-form-input
                          v-model="filterPermission"
                          type="search"
                          :placeholder="`Search in page ${paginationPermission.pageNo} `"
                          class="form-control form-control-sm ml-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>
                <div
                  class="row"
                  v-if="
                    paginationPermission.items &&
                    paginationPermission.items.length > 0
                  "
                >
                  <div class="col-lg-4">
                    <div style="position: relative; top: 7px">
                      Result
                      {{
                        (paginationPermission.pageNo - 1) *
                          paginationPermission.pageSize +
                        1
                      }}
                      -
                      {{
                        paginationPermission.pageNo *
                          paginationPermission.pageSize >
                        paginationPermission.totalRecords
                          ? paginationPermission.totalRecords
                          : paginationPermission.pageNo *
                            paginationPermission.pageSize
                      }}
                      From {{ paginationPermission.totalRecords }} Records
                    </div>
                  </div>
                  <div class="col-lg-8">
                    <b-pagination
                      :total-rows="paginationPermission.totalRecords"
                      :per-page="paginationPermission.pageSize"
                      v-model="paginationPermission.pageNo"
                      @change="onClickPagination($event)"
                      class="pagination pagination-rounded justify-content-end mb-2"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <b-table
                        class="table table-centered table-nowrap"
                        ref="usertable"
                        :empty-text="'Not found any result'"
                        :show-empty="paginationPermission.items.length == 0"
                        :bordered="true"
                        :filter="filterPermission"
                        :items="paginationPermission.items"
                        align="center"
                        v-bind:fields="permissionTablefields"
                        :perPage="paginationPermission.pageSize"
                      >
                        <template v-slot:head(id)>
                          Select
                          <b-form-checkbox
                            v-show="isViewObjectPermissions"
                            v-model="selectAll"
                            @change="toggleSelectAll($event)"
                            class="custom-checkbox-info"
                          >
                          </b-form-checkbox>
                        </template>
                        <template v-slot:cell(id)="data">
                          <div class="text-center">
                            <b-form-checkbox
                              v-model="permissionSelected"
                              :value="data.item"
                              class="custom-checkbox-info mb-3"
                              checked
                            ></b-form-checkbox>
                          </div>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 text-sm-right">
                    <div class="button-items">
                      <button
                        v-show="permissionSelected && permissionSelected.length"
                        type="button"
                        class="btn btn-primary"
                        @click="addViewPermission()"
                      >
                        Apply
                      </button>
                      <button type="button" class="btn btn-secondary">
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <loading :active.sync="isLoading" ></loading>

          </div>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>
<script>
import permissionProvider from "@/helpers/service/permission-provider";
import viewProvider from "@/helpers/service/view-provider";
import { watch } from "vue";
import { computed } from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  props: {
    toggleSideBar: {
      type: Boolean,
      default: false,
    },
    applicationCode: {
      type: String,
      default: "",
    },
    viewId: {
      type: String,
      default: "",
    },
  },
  components: {Loading},

  data() {
    return {
      isLoading:false,
      showDataTable:false,
      selectAll: false,
      paginationPermission: {
        totalRecords: 0,
        pageNo: 0,
        pageSize: 50,
        totalPages: 0,
        hasPreviousPage: true,
        hasNextPage: true,
        items: [],
      },
      pageOptions: [5, 10, 25, 50, 100],
      permissionTablefields: [
        {
          key: "id",
          label: "Select",
          thStyle: "width:80px",
          class: "text-center",
          sortable: false,
        },
        {
          key: "display_name",
          label: "Display Name",
          sortable: true,
        },
        {
          key: "action",
          label: "Action Privilege",
          sortable: true,
        },
        {
          key: "method",
          label: "Method",
          sortable: true,
        },
        {
          key: "controller",
          label: "Category",
          sortable: true,
        },
        {
          key: "version",
          label: "Version",
          sortable: true,
        },
      ],
      permissionSelected: [],
      filterPermission: "",
      filter: {
        keyword: "",
        areaDropdwon: "",
        privilegeDropdwon: "",
        categoryDropdwon: "",
        typeDropdwon: "",
      },
      viewStatus: ["Active", "Delete"],
    };
  },
  mounted() {
    // console.log("mounted", this.toggleSideBar);
    // this.selectAll = false;
    // this.paginationPermission.items = [];
    // this.permissionSelected = [];
    // this.selectAll = false
  },

  // watch: {
  //   permissionSelected(newVal) {
  //     let selectAll = false
  //     this.paginationPermission.items.forEach((item) => {
  //       if (!newVal.includes(item)) {
  //         selectAll = false;
  //       }
  //     });
  //     this.selectAll = selectAll;
  //   },
  // },
  computed: {
    isViewObjectPermissions() {
      return this.$validate.anyArrayObjectValid(
        this.paginationPermission.items
      );
    },
  },
  watch: {
    toggleSideBar(newVal) {
      if (!newVal) {
        this.showDataTable = false
        this.selectAll = false;
        this.paginationPermission.items = [];
        this.permissionSelected = [];
        this.filter = {
          keyword: "",
        areaDropdwon: "",
        privilegeDropdwon: "",
        categoryDropdwon: "",
        typeDropdwon: "",
        }
      }
    },
  },
  methods: {
    toggleSelectAll(newVal) {
      this.permissionSelected = newVal
        ? this.paginationPermission.items.slice()
        : [];
    },
    async onClickPagination(pageNo) {
      this.selectAll = false;
      await this.onFilter(pageNo);
    },
    async onFilter(pageNo = 0) {
      this.isLoading = true
      let params = new URLSearchParams();
      params.append("pageSize", this.paginationPermission.pageSize);
      if (pageNo > 0) params.append("pageNo", pageNo);
      params.append("name", this.filter.keyword.trim() || "");
      let result = await permissionProvider.getPermissionsAsync(
        this.applicationCode,
        params
      );
      if (result.status === 200) {
        this.isLoading = false
        this.paginationPermission = result.data;
        this.showDataTable = true;

      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },

    async addViewPermission() {
      this.isLoading = true
      let apiData = {
        permissions: this.permissionSelected,
      };
      let result = await viewProvider.createViewPermissionAsync(
        this.applicationCode,
        this.viewId,
        apiData
      );

      if (result.status === 201) {
        this.$emit("getViewById", this.viewId, true);
        this.isLoading = false

        this.$utils.notification("success", "View is updated", 1500);
        this.permissionSelected = [];
        this.paginationPermission.items = [];
        this.selectAll = false;
        this.$emit("hidden");
      }
    },
  },
};
</script>
